import * as Actions from './SessionDetailsActions';
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { getSessionDetails, getAttendeeDetailsPerSession } from '../../Apis/ReportingReadApi';
import { forceLoginIfExpired } from '../Utils/RedirectionUtils';

export function* getSessionDetailsWatcher() {
  yield takeLatest(Actions.GET_SESSION_DETAILS_REQUEST, getSessionDetailsWorker);
}

export function* getSessionDetailsWorker({ payload }) {
  const { sessionKey } = payload;

  try {
    const axiosResponse = yield call(getSessionDetails, sessionKey);
    const sessionDetails = axiosResponse.data;
    yield put({
      type: Actions.GET_SESSION_DETAILS_SUCCESS,
      payload: { sessionDetails }
    });
    yield fork(getAttendeePerSessionWorker, {
      type: Actions.GET_SESSION_DETAILS_ATTENDEE_COUNT_REQUEST,
      sessionDetails
    });
  } catch (error) {
    yield put({ type: Actions.GET_SESSION_DETAILS_FAILURE, error });
    forceLoginIfExpired(error);
  }
}

function* getAttendeePerSessionWorker(sessionDetails) {
  let sessionAttendeeDetailsPerSession = {};
  try {
    const { sessionKey, webinarKey } = sessionDetails.sessionDetails;
    const axiosResponse = yield call(getAttendeeDetailsPerSession, webinarKey, sessionKey);
    sessionAttendeeDetailsPerSession = axiosResponse.data;
    yield put({
      type: Actions.GET_SESSION_DETAILS_ATTENDEE_COUNT_SUCCESS,
      payload: { sessionAttendeeDetailsPerSession }
    });
  } catch (error) {
    yield put({ type: Actions.GET_SESSION_DETAILS_ATTENDEE_COUNT_FAILURE, error });
    forceLoginIfExpired(error);
  }
}

export default function* rootSaga() {
  yield all([fork(getSessionDetailsWatcher)]);
}



// WEBPACK FOOTER //
// ./src/Reducks/SessionDetails/SessionDetailsSagas.js